import React, { useEffect, useState } from "react";
import CustomDataTable from "components/customs/table";
import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import {
  fetchCongressmen,
  fetchPartylists,
} from "services/services.affiliation";
import { defaultTableOption, rowPerPage } from "constants/table";
import styled from "styled-components";
import DropdownSelect from "components/customs/dropdownSelect";
import { columns } from "./columns";

const Wrapper = styled.div`
  margin-top: 50px;
`;

const CardSection = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 15px;
  box-shadow: 4px 9px 17px -1px #00000014;
`;

const CardContainer = styled.div`
  padding-top: 24px;
  padding-left: 50px;
  padding-right: 50px;
  padding-bottom: 24px;
`;

const FilterSection = styled.div`
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: 500px;

  @media (max-width: 575.98px) {
    grid-template-columns: 100%;
  }
`;

const StyledImage = styled.img`
  height: 70px;
  width: 70px;
  margin-right: 0.5rem;
`;

const getSelectorOptions = (rawOptions) => {
  const options =
    rawOptions?.map((select) => ({
      ID: select?.id,
      Name: select?.name,
      label: select?.name,
      displayLabel: (
        <div>
          <StyledImage
            src={select.photo}
            alt="party-logo"
          />
          {select?.name}
        </div>
      ),
    })) || [];

  return options;
};

const Main = () => {
  const [tableOption, setTableOption] = useState({
    ...defaultTableOption,
    currentRowsPerPage: rowPerPage,
  });
  const [selectedProject, setSelectedProject] = useState(null);

  const [selectorOptions, setSelectorOptions] = useState([]);
  const [data, setData] = useState([]);
  const [partyList, setPartyList] = useState([]);

  const { id } = useParams();

  const navigate = useNavigate();

  let changeSearchTimeoutID;

  // eslint-disable-next-line no-unused-vars
  const onChangeSearch = (event) => {
    event.persist();

    if (changeSearchTimeoutID) {
      clearTimeout(changeSearchTimeoutID);
    }

    changeSearchTimeoutID = setTimeout(() => {
      const eventValue = event.target.value;

      const newData = data.filter(
        (__data) =>
          __data.fullName
            .toLowerCase()
            .includes(eventValue.toLowerCase().trim()) ||
          __data.District.name
            .toLowerCase()
            .includes(eventValue.toLowerCase().trim())
      );

      setTableOption({
        ...tableOption,
        page: 1,
        data: newData,
      });
    }, 1000);
  };

  const handleSelectOnChange = (option) => {
    setSelectedProject(option);
  };

  const fetchTable = () => {
    setTableOption({
      ...tableOption,
      isLoading: true,
    });

    fetchCongressmen({
      param: selectedProject?.ID,
      callback: (Data) => {
        const newData = Data?.length !== 0 ? Data : [];
        setData(newData);

        setTableOption({
          ...tableOption,
          data: newData,
          isLoading: false,
          totalRows: newData?.length,
        });
      },
    });
  };

  const fetchParties = () => {
    fetchPartylists({
      callback: (Data) => {
        const newData = Data?.length !== 0 ? Data : [];
        const options = getSelectorOptions(newData);
        setSelectorOptions(options);
        setPartyList(newData);
      },
    });
  };

  const handleOnRowClicked = (row) => {
    navigate(`/representatives/${row?.District?.RegionId}/cong/${row.id}`);
  };

  useEffect(() => {
    fetchParties();
  }, []);

  useEffect(() => {
    if (selectedProject) fetchTable();
  }, [selectedProject]);

  useEffect(() => {
    if (selectorOptions?.length !== 0 && partyList?.length !== 0) {
      // eslint-disable-next-line array-callback-return
      partyList?.map((op, index) => {
        if (op?.id === Number(id)) {
          setSelectedProject(selectorOptions[index]);
        }
      });
    }
  }, [partyList]);

  return (
    <Wrapper>
      <CardSection>
        <CardContainer>
          <FilterSection>
            <DropdownSelect
              isLoading={tableOption.isLoading}
              isDisabled={tableOption.isLoading}
              onChange={(option) => handleSelectOnChange(option)}
              value={selectedProject}
              options={selectorOptions}
            />
          </FilterSection>

          {/* table here */}
          <CustomDataTable
            columns={columns}
            data={tableOption.data}
            noHeader
            paginationPerPage={tableOption.currentRowsPerPage}
            paginationServer
            paginationTotalRows={tableOption.totalRows}
            progressPending={tableOption.isLoading}
            sortServer
            height="calc(100vh - 200px)"
            onRowClicked={handleOnRowClicked}
          />
        </CardContainer>
      </CardSection>
    </Wrapper>
  );
};

export default Main;
